import Vue from 'vue'
import Router, { isNavigationFailure, NavigationFailureType } from 'vue-router'
// import Home from '@/views/Home.vue'
import Member from '@/views/Member.vue'
Vue.use(Router)

// 路由重复点击、上一次跳转被新跳转取消都属于无害中断，
// 统一在内部消化，避免冒成未捕获异常弹出开发环境的错误遮罩
const silenceNavigation = key => {
  const origin = Router.prototype[key]
  Router.prototype[key] = function (location, onResolve, onReject) {
    if (onResolve || onReject) {
      return origin.call(this, location, onResolve, onReject)
    }
    return origin.call(this, location).catch(err => {
      if (isNavigationFailure(err, NavigationFailureType.cancelled) ||
        isNavigationFailure(err, NavigationFailureType.duplicated)) {
        return err
      }
      return Promise.reject(err)
    })
  }
}
silenceNavigation('push')
silenceNavigation('replace')

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Member',
      component: Member
    },
    {
      path: '/Home',
      name: 'Home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/Detail',
      name: 'Detail',
      component: () => import('@/views/Detail.vue')
    },
    {
      path: '/Consultation',
      name: 'Consultation',
      component: () => import('@/views/Consultation.vue')
    },
    {
      path: '/Prescription',
      name: 'Prescription',
      component: () => import('@/views/Prescription.vue')
    },
    {
      path: '/message',
      name: 'message',
      component: () => import('@/views/message.vue')
    },
    {
      path: '/record',
      name: 'record',
      component: () => import('@/views/record.vue')
    },
  ]
})